export interface HeaderProps {
  columns: string[]
}

const Header = ({ columns }: HeaderProps) => (
  <thead>
    <tr>
      {columns.map((column, index) => (
        <th key={index}>{column}</th>
      ))}
    </tr>
  </thead>
)

export default Header
